module.exports = __webpack_public_path__ + "img/Banana.444c943e.svg";